import { LINXFOUR_MASTER_USER_ID } from '@/data/constants'

export function isActAsOemActive(userStore) {
    const userData = userStore?.userData
    if (!userData) return false
    if (!userData.permissions?.includes('login as oem')) return false

    const { owned_by } = userData

    if (owned_by == null) return false

    return Number(LINXFOUR_MASTER_USER_ID) !== Number(owned_by)
}
